import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';
import { useTireImages } from '../../hooks/useTireImages';

const generalSections = [
  'driver_front_tire',
  'driver_front_wheel',
  'passenger_front_tire',
  'passenger_front_wheel',
  'driver_rear_tire',
  'driver_rear_wheel',
  'passenger_rear_tire',
  'passenger_rear_wheel',
  'tires_match_manufacturer'
];

export const Tires = () => {
  const { subSections } = useExteriorSectionData('tires');
  const orderedImages = useTireImages();

  return (
    <Level2Wrapper flex="1 1 100%" label="Tires">
      <ImageList label="Tires Pictures" images={orderedImages} />
      {generalSections.map(sectionKey => {
        const section = subSections[sectionKey];
        if (!section) return null;
        let numericGrade: undefined | number = undefined;
        if (sectionKey.endsWith('_tire')) {
          const image = orderedImages.find(img => img.type === `tires.${sectionKey}`);
          numericGrade = image?.grade;
        }
        if (!section.grade && !numericGrade) return null;
        return (
          <GenericSubSection key={sectionKey} section={subSections[sectionKey]} additionalData={{ numericGrade }} />
        );
      })}
    </Level2Wrapper>
  );
};
